<template>
    <el-dialog title="信息核对" :visible.sync="dialogVisible" width="60%">
        <div class="box-card" v-if="Object.keys(infoData).length">
            <template v-if="infoData.productInfos.length">
                <el-row class="custom-container" v-for="item in infoData.productInfos" :key="item.id">
                    <el-col :span="4">
                        <el-image
                            style="width: 100%; height: 100%;"
                            :src="item.imageUrl"
                            :preview-src-list="item.imageUrl.split(',')"
                        ></el-image>
                    </el-col>
                    <el-col :span="18" :offset="2">
                        <div class="inform flex">
                            <div class="title">亚马逊订单号：</div>
                            <div>{{ infoData.amazonOrderId }}</div>
                        </div>
                        <div class="inform flex">
                            <div class="title">标题：</div>
                            <div>{{ item.title }}</div>
                        </div>
                        <div class="inform flex">
                            <div class="title">SKU：</div>
                            <div>{{ item.sku }}</div>
                        </div>

                        <el-row type="flex" justify="space-between">
                            <div class="inform flex">
                                <div class="title">数量：</div>
                                <div>{{ item.quantityOrdered }}</div>
                            </div>
                            <!-- <el-button type="text">打印（0）</el-button> -->
                        </el-row>
                        <el-row type="flex" style="align-items: center;">
                            <el-tag v-if="infoData.outInterceptStatus === 1" type="danger" effect="dark" style="font-size: 18px;">拦截</el-tag>
                            <el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom" v-if="infoData.isFreeze === 1">
                                <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
                            </el-tooltip>
                        </el-row>
                    </el-col>
                </el-row>
            </template>
            <div class="custom-container">
                <div style="width:100%;">
                    <el-divider></el-divider>
                    <div style="display:flex;">
                    <div style="width:60%;">
                        <el-row>
                            <el-col :span="12">
                                <div class="inform">采购单据号：{{ infoData.purchaseNumber }}</div>
                            </el-col>
                            <el-col :span="12">
                                <div class="inform">运单号：{{ infoData.internalConveyNumber }}</div>
                            </el-col>
                        </el-row>
                        <div class="inform" v-if="infoData.insertFrom == 0" style="font-weight: bold;font-size: 18px;color: red;">海逊仓库核对详情：{{infoData.purchaseModel}}</div>
                        <div class="inform" v-if="infoData.insertFrom !== 0" style="font-weight: bold;font-size: 18px;color: blue;">海逊仓库核对详情：{{infoData.purchaseModel}}</div>
                        <el-row>
                            <el-col :span="12">
                                <div class="inform">入库尺寸：{{ infoData.purchaseSize }}</div>
                            </el-col>
                            <el-col :span="12">
                                <div class="inform">入库重量：{{ infoData.purchaseWeight }}</div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div class="inform">材积重：{{ infoData.purchaseSize }}</div>
                            </el-col>
                            <el-col :span="12">
                                <div class="inform">计费重：{{ infoData.purchaseWeight }}</div>
                            </el-col>
                        </el-row>
                        <div class="inform">货物等级：{{ infoData.purchaseClass }}</div>
                        <div class="inform">
                            <h4>异常信息：</h4>
                            <div style="padding:0 10px;">
                                <template v-for="item in infoData.exceptionImages">
                                    <el-image
                                        :key="item"
                                        style="width: 100px; height: 100px"
                                        :src="item"
                                        fit="fit"
                                        :preview-src-list="infoData.exceptionImages"
                                    ></el-image>
                                    <!-- <el-image :key="item" :src="item"></el-image> -->
                                </template>
                                <div class="inform" style="color: red;">{{ infoData.exceptionRemark }}</div>
                            </div>
                        </div>
                        <el-row type="flex" align="middle" style="margin: 10px 0;">
                          <h4>处理方案：</h4>
                          <div>{{ infoData.handleDescription }}</div>
                         
                        </el-row>
                         <div class="ProductMsg" v-if="infoData.receivingAddress">
                              <p> <span>收件人：</span> {{infoData.receivingAddress.recipientName}}</p>
                              <p> <span>收件人电话：</span> {{infoData.receivingAddress.recipientTelephone  }}</p>
                              <p> <span>收货地址：</span> {{infoData.receivingAddress.receivingAddress}}</p>
                          </div>
                        </div>
                        <div style="width:40%;">
                            <img :src="pics" alt="" v-if="infoData.invalidStatus === 0" style="width:200px;">
                        </div>
                        </div>

                        <div class="custom-container" style="margin-top:30px;margin-bottom:30px;">
                        <div style="width:100%;">
                            <el-row type="flex">
                            <el-collapse style="width:100%;margin-top:30px;">
                                <el-collapse-item title="物流内部备注">
                                <div><el-button type="primary" size="mini" @click="InRemarks = true">添加备注</el-button></div>
                                <el-divider></el-divider>
                                <div style="display: flex;justify-content: space-between;margin-top:15px;" v-for="item in this.RemarkList">
                                    <p style="width:10%;">{{item.roleName}}</p>
                                    <p style="width:75%;">{{item.remarkContent}}</p>
                                    <p style="width:15%;">{{item.createTime}}</p>
                                </div>
                                </el-collapse-item>
                            </el-collapse>
                            </el-row>
                        </div>
                        </div>

                        <el-dialog width="30%" title="添加物流内部备注" :visible.sync="InRemarks" append-to-body>
                            <el-input v-model="remarksInput"></el-input>
                            <div slot="footer" class="dialog-footer">
                            <el-button @click="InRemarks = false">取 消</el-button>
                            <el-button type="primary" @click="AddRemarks">确定</el-button>
                            </div>
                        </el-dialog>

                        <el-row type="flex" justify="end">
                            <el-button v-if="infoData.ifCancel" type="primary" @click="infoChange('Cancel')">
                                取消异常
                            </el-button>
                            <el-button v-if="infoData.ifPutStorage" type="primary" @click="infoChange('PutStorage')">
                                转库存
                            </el-button>
                            <el-button v-if="infoData.ifReturn" type="primary" @click="infoChange('Return')">
                                退件
                            </el-button>
                            <el-button v-if="infoData.ifUnknown" type="primary" @click="infoChange('Unknown')">
                                转未知
                            </el-button>
                        </el-row>
                    
                </div>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
    name: "ServiceDepartment",
    data() {
        var pics = require('../../../assets/imags/pics.png')
        return {
            pics:pics,
            dialogVisible: false,
            infoData: {},
            InRemarks:false,
            remarksInput:"",
            RemarkList:[],
            sondata:"",
            inventoryActualCount:"",
            endReason:""
        };
    },
    methods: {
        init(row) {
            this.dialogVisible = true;
            this.infoData = row;
            this.sondata = row;
            this.sondataAjax()
        },
        close() {
            this.dialogVisible = false;
            this.infoData = {};
        },
        sondataAjax(){
            const API = Baseurl + 'logisticsController/getServicePurchaseDetails'
            const paramsData = {
                id: this.sondata.id
            }
            ajaxPost(API, paramsData).then(res => {
                if (res.data.code === 200) {
                    this.infoData = res.data.data;
                    this.sondata = res.data.data;
                } else {
                    this.$message.error(res.data.data)
                }
            })
        },
        // 信息报错 信息确认
        infoChange(type) {
            // console.log(type)
            const handleRequest = () => {
                let paramsData = {
                    id: this.infoData.id,
                    orderId: this.infoData.orderId,
                };
                const operate = {
                    Cancel: () => {
                        paramsData.exceptionResult = "6";
                    },
                    PutStorage: () => {
                        paramsData.exceptionResult = "4";
                        paramsData.inventoryActualCount = this.inventoryActualCount;
                    },
                    Return: () => {
                        paramsData.exceptionResult = "2";
                    },
                    Unknown: () => {
                        paramsData.exceptionResult = "10";
                    },
                };
                operate[type]();
                this.$emit("confirm", paramsData);
            };
            if(type == 'PutStorage'){
                this.$prompt('请输入申请数量', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.inventoryActualCount = value
                    handleRequest();
                })
                        // const h = this.$createElement;
                        // this.$msgbox({
                        // title: '提示',
                        // message: h('p', null, [
                        //     h('p', null, '请输入申请数量 '),
                        //     h('el-input-number', { attrs: {size: "mini", min:1,max:9999,value: this.endReason,id:"hinput"},on: {input: this.handleClick} })
                        // ]),
                        // showCancelButton: true,
                        // confirmButtonText: '确定',
                        // cancelButtonText: '取消',
                        // beforeClose: (action, instance, done) => {
                        //     if (action === 'confirm') {
                        //         console.log(this.endReason)
                        //         done();
                        //     } else {
                        //         done();
                        //     }
                        // }
                        // }).then((action) => {
                        //     // console.log(action)
                        //     // console.log(this.endReason)
                        // });
            }else{
                this.$confirm("您确定要执行此操作吗？", "提示").then(() => {
                    handleRequest();
                });
            }
        },
        handleClick() {
            var a=document.getElementById("hinput").value;
            this.endReason = a
            console.log(this.endReason)
        },
        RemarkListAjax(){
        const API = Baseurl + 'logisticsRemarkController/selectLogisticsRemarkList'
        const paramsData = {
            orderId: this.sondata.orderId
        }
        ajaxPost(API, paramsData).then(res => {
            if (res.data.code === 200) {
            this.RemarkList = res.data.data
            } else {
            this.$message.error(res.data.data)
            }
        })
        },
        AddRemarks(){
        var str = JSON.parse(localStorage.getItem("role"));
        const API = Baseurl + 'logisticsRemarkController/insertLogisticsRemark'
        const paramsData = {
            orderId: this.sondata.orderId,
            remarkContent:this.remarksInput,
            amazonOrderId:this.sondata.amazonOrderId,
            roleId:str.rid,
            companyId:str.company_id
        }
        ajaxPost(API, paramsData).then(res => {
            if (res.data.code === 200) {
            this.$message({
                type:"success",
                message:"添加物流内部备注成功"
            })
            this.RemarkListAjax()
            } else {
            this.$message.error(res.data.data)
            }
            this.remarksInput = ""
            this.InRemarks = false
        })
        }
    },
};
</script>
<style lang="scss" scoped>
.custom-container {
    padding: 0 20px;
    display: flex;
    align-items: center;
}
.inform {
    line-height: 30px;
    &.flex {
        display: flex;
        .title {
            flex-shrink: 0;
            font-weight: bold;
        }
    }
}
.right-btn-container {
    display: flex;
    justify-content: flex-end;
}
.el-popover {
    position: absolute;
    background: #fff;
    min-width: 200px;
    border: 1px solid #ebeef5;
    padding: 12px;
    left: 40%;
    right: 0%;
    top: -17%;
    color: #606266;
    line-height: 1.4;
    text-align: justify;
    font-size: 14px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: none;
    z-index: 9998;
    img {
        width: 90%;
    }
}
.padding0 {
    padding: 0;
}
.ProductMsg{
    padding-left: 10px;
    span{
        color: #606266;
    }
}
</style>
